import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { HomeCardStyles } from './HomeCard.styled';
import FavoritingHeart from '@components/Shared/Favoriting/FavoritingHeart';
import { formatNumberWithCommas } from 'pubweb-smokey/dist/utils/formatters';
import { modelNameTransformer } from 'pubweb-smokey/dist/utils/modelNameTransformer';
import { Carousel } from 'react-responsive-carousel';

const HomeCard = (props) => {
  /* 
            some may want to pass all params in an object 
            (even though they could just use spread op),
            so to support that and be flexible for existing code, 
            we combine props here
        */
  const {
    className,
    images,
    imgComponent,
    imageQueryString,
    showPricing = true,
    showFavoritingHeart = false,
    stickers = [],
    isInStock = false,
    showStockIndicator = false,
    showSpecs = true,
    cardLink,
    cardLinkTarget,
    isFavorited,
    handleFavoriteClick,
    description = props.homeObject && props.homeObject.modelDescription
      ? props.homeObject.modelDescription
      : props.description,
    beds,
    baths,
    squareFeet = props.homeObject?.maxSquareFeet,
    customPriceMarkupCallback,
    lowPrice,
    useSlideshow = true,
    showArrows = false,
    autoPlay = false,
    showIndicators = false,
    showThumbs = false,
    swipeable = true,
    emulateTouch = true,
    infiniteLoop = true,
    dynamicHeight = false,
    viewportWidth = 500,
    forceExternalLink = false,
    homeObject,
    acres,
  } = { ...props.homeObject, ...props };
  // this is to make sure an image is loaded when we detect
  // image dimensions (to see if it's horizontal or vertical)
  const singleImageRef = useRef(null);
  const [singleImageRefVisible, setSingleImageRefVisible] = useState(false);

  useEffect(() => {
    if (!singleImageRefVisible) {
      return;
    }
  }, [singleImageRefVisible]);

  let altText =
    homeObject &&
    homeObject.modelDescription &&
    typeof homeObject.modelDescription === 'string'
      ? modelNameTransformer(homeObject.modelDescription)
      : '';

  //For homeObjectsthat are not a straight up string description ("Save your favorite homes")
  //Only if we have the property though!
  if (homeObject && typeof homeObject.altTextDescription !== 'undefined') {
    altText = homeObject.altTextDescription;
  }

  let imageQueryStringResult = imageQueryString || '?width=500';

  const renderCard = () => {
    const cardClasses = useSlideshow
      ? 'card-image-area card-slideshow'
      : 'card-image-area';

    return (
      <>
        <div className={cardClasses}>
          {/* this is a trick I invtented to hold the aspect ratio of the card no matter what
                        size image we throw at it, even a vertical one (happens rarely, but does happen). 
                        it's transparent, has default positioning, and hides behind everything else.
                        
                        The image fed into the card has absolute positioning, so it will not affect the
                        dimensions of the card, so cards will stay consistent with one another*/}
          <img
            src="data:image/gif;base64,R0lGODlhRQHjAIAAAP///wAAACH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNi4wLWMwMDIgNzkuMTY0MzYwLCAyMDIwLzAyLzEzLTAxOjA3OjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjEuMSAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjU2OEExQkNFMjJEMTFFQTlFNjVGQTE2REJGNkZDMzYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjU2OEExQkRFMjJEMTFFQTlFNjVGQTE2REJGNkZDMzYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCNTY4QTFCQUUyMkQxMUVBOUU2NUZBMTZEQkY2RkMzNiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCNTY4QTFCQkUyMkQxMUVBOUU2NUZBMTZEQkY2RkMzNiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgH//v38+/r5+Pf29fTz8vHw7+7t7Ovq6ejn5uXk4+Lh4N/e3dzb2tnY19bV1NPS0dDPzs3My8rJyMfGxcTDwsHAv769vLu6ubi3trW0s7KxsK+urayrqqmop6alpKOioaCfnp2cm5qZmJeWlZSTkpGQj46NjIuKiYiHhoWEg4KBgH9+fXx7enl4d3Z1dHNycXBvbm1sa2ppaGdmZWRjYmFgX15dXFtaWVhXVlVUU1JRUE9OTUxLSklIR0ZFRENCQUA/Pj08Ozo5ODc2NTQzMjEwLy4tLCsqKSgnJiUkIyIhIB8eHRwbGhkYFxYVFBMSERAPDg0MCwoJCAcGBQQDAgEAACH5BAEAAAAALAAAAABFAeMAAAL/hI+py+0Po5y02ouz3rz7D4biSJbmiabqyrbuC8fyTNf2jef6zvf+DwwKh8Si8YhMKpfMpvMJjUqn1Kr1is1qt9yu9wsOi8fksvmMTqvX7Lb7DY/L5/S6/Y7P6/f8vv8PGCg4SFhoeIiYqLjI2Oj4CBkpOUlZaXmJmam5ydnp+QkaKjpKWmp6ipqqusra6voKGys7S1tre4ubq7vL2+v7CxwsPExcbHyMnKy8zNzs/AwdLT1NXW19jZ2tvc3d7f0NHi4+Tl5ufo6err7O3u7+Dh8vP09fb3+Pn6+/z9/v/w8woMCBBAsaPIgwocKFDBs6fAgxosSJFCtavIgxo8aNeBw7evwIMqTIkSRLmjyJMqXKlSxbunwJM6bMmTRr2ryJM6fOnTx7+vwJNKjQoUSLGj2KNKnSpUybOn0KNarUqVSrWr2KNavWrVy7ev0KNqzYsWTLmj2LNq3atWzbun0LN67cuXTr2r2LN6/evXz7+v0LOLDgwfMKAAA7"
            alt=""
            className="aspect-ratio-sizer"
          />

          {/* to enable the slideshow you must pass in an array with more than one image
                        AND set useSlideshow to true */}
          {useSlideshow && images && images.length > 1 ? (
            <Carousel
              showArrows={showArrows}
              autoPlay={autoPlay}
              showIndicators={showIndicators}
              showThumbs={showThumbs}
              swipeable={swipeable}
              emulateTouch={emulateTouch}
              infiniteLoop={infiniteLoop}
              dynamicHeight={dynamicHeight}
              showStatus={false}
              renderArrowPrev={(onClickHandler, hasPrev, label) =>
                hasPrev && (
                  <button
                    type="button"
                    className="control-arrow control-prev"
                    onClick={(ev) => {
                      ev.preventDefault();
                      onClickHandler();
                    }}
                    title={label}
                  ></button>
                )
              }
              renderArrowNext={(onClickHandler, hasNext, label) =>
                hasNext && (
                  <button
                    type="button"
                    className="control-arrow control-next"
                    onClick={(ev) => {
                      ev.preventDefault();
                      onClickHandler();
                    }}
                    title={label}
                  ></button>
                )
              }
            >
              {/* {images.map((image, i) => {
                                    return (
                                        <div className="">
                                            <AspectImage
                                                aspectRatio={1.5}
                                                behavior="fill-container" 
                                                src={image.reference + imageQueryStringResult} 
                                                alt={altText}                                                
                                            />
                                        </div>
                                    );
                                })} */}

              {images.map((image, i) => {
                if (image.reference) {
                  return (
                    <div key={i}>
                      {imgComponent ? (
                        React.createElement(imgComponent, {
                          src: image.reference + imageQueryStringResult,
                          alt: altText,
                          fill: true,
                        })
                      ) : (
                        <img
                          src={image.reference + imageQueryStringResult}
                          alt={altText}
                        />
                      )}
                    </div>
                  );
                } else {
                  return image;
                }
              })}
            </Carousel>
          ) : (
            <div className="card-image-single">
              {images && images[0] && images[0].reference && imgComponent ? (
                React.createElement(imgComponent, {
                  src: images[0].reference + imageQueryStringResult,
                  alt: altText,
                  ref: (e) => {
                    singleImageRef.current = e;
                    setSingleImageRefVisible(!!e);
                  },
                  className:
                    singleImageRef &&
                    singleImageRef.current &&
                    singleImageRef.current.naturalHeight >
                      singleImageRef.current.naturalWidth
                      ? 'img-vertical'
                      : 'img-horizontal',
                  fill: true,
                })
              ) : (
                <img
                  src={images[0].reference + imageQueryStringResult}
                  alt={altText}
                  ref={(e) => {
                    singleImageRef.current = e;
                    setSingleImageRefVisible(!!e);
                  }}
                  className={
                    singleImageRef &&
                    singleImageRef.current &&
                    singleImageRef.current.naturalHeight >
                      singleImageRef.current.naturalWidth
                      ? 'img-vertical'
                      : 'img-horizontal'
                  }
                />
              )}
            </div>
          )}

          {/* In stock indicator and/or stickers. */}
          {((isInStock && showStockIndicator) ||
            (stickers && stickers.length > 0)) && (
            <div className="sticker-container">
              {/* If 'in stock' indicator selected, display it. */}
              {isInStock && showStockIndicator && (
                <div className="sticker label in-stock">
                  <div className="sticker-dot in-stock-dot">&nbsp;</div> In
                  Stock
                </div>
              )}
              {/* Display any stickers from the sticker array. */}
              {stickers &&
                stickers.length > 0 &&
                stickers.map((sticker) => {
                  return (
                    sticker?.label && (
                      <div
                        className="sticker label"
                        key={`sticker-${sticker.label}`}
                      >
                        <div
                          className="sticker-dot"
                          style={{
                            backgroundColor: sticker.dotColor || '#0075C9',
                          }}
                        >
                          &nbsp;
                        </div>{' '}
                        {sticker.label}
                      </div>
                    )
                  );
                })}
            </div>
          )}

          {showFavoritingHeart && (
            <div className="favoriting-heart-container-card">
              <FavoritingHeart
                isFavorited={isFavorited}
                onClick={handleFavoriteClick}
              />
            </div>
          )}
        </div>

        <div className="card-info-area">
          <div>
            {description && (
              <h5 className="card-heading">
                {modelNameTransformer(description)}
              </h5>
            )}

            {showSpecs ? (
              <p className="card-home-specs caption">
                {homeObject && beds && (
                  <>{beds > 1 ? beds + ' beds' : beds + ' bed'}</>
                )}
                <> &bull; </>
                {baths && <>{baths > 1 ? baths + ' baths' : baths + ' bath'}</>}
                <> &bull; </>
                {squareFeet
                  ? formatNumberWithCommas(squareFeet) + ' sq. ft.'
                  : null}
                {acres && <> &bull; {acres + ' acres'}</>}
              </p>
            ) : null}
          </div>

          {lowPrice && showPricing && (
            <div className="price">
              <p className="label">Starting in the</p>
              <p className="intro">
                ${lowPrice && formatNumberWithCommas(lowPrice) + 's*'}
              </p>
            </div>
          )}

          {customPriceMarkupCallback && <>{customPriceMarkupCallback()}</>}
        </div>
      </>
    );
  };

  //A lot of these are brute force trial-by-error calcs. If you find something better, place it here!
  const calculateCarousel = (width) => {
    if (width < 650) {
      return 1.63;
    } else if (width < 769) {
      return 2.06;
    } else if (width < 900) {
      return 3.26;
    } else if (width < 960) {
      return 3.23;
    } else if (width < 1010) {
      return 4.85;
    } else if (width < 1100) {
      return 5.02;
    } else {
      return 1.63;
    }
  };

  const widthPercent = calculateCarousel(viewportWidth);

  //Height of the container (To make it look nice and uniform on the page. 245px is the smallest we'll go!)
  const adjustedHeight =
    viewportWidth < 1100 ? viewportWidth / widthPercent : 245;

  return (
    <HomeCardStyles
      $adjustedHeight={adjustedHeight}
      $useSlideshow={useSlideshow}
    >
      {(() => {
        const safeCardLink = (cardLink || '').toLowerCase();

        if (safeCardLink) {
          if (
            safeCardLink.indexOf('http://') === 0 ||
            safeCardLink.indexOf('https://') === 0 ||
            forceExternalLink
          ) {
            return (
              <a
                className={className ? className : 'home-card-link'}
                target={cardLinkTarget || '_blank'}
                href={cardLink}
              >
                {renderCard()}
              </a>
            );
          } else {
            return (
              <Link
                onClick={props.onClick}
                href={cardLink}
                className={className ? className : 'home-card-link'}
              >
                {renderCard()}
              </Link>
            );
          }
        }

        return renderCard();
      })()}
    </HomeCardStyles>
  );
};

HomeCard.propTypes = {
  homeObject: PropTypes.shape({
    numberInStock: PropTypes.number,
    modelId: PropTypes.number,
    modelNumber: PropTypes.string,
    modelDescription: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    description: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    baths: PropTypes.number,
    beds: PropTypes.number,
    squareFeet: PropTypes.number,
    lowPrice: PropTypes.number,
    virtualTourReference: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    hasVirtualTour: PropTypes.bool,
    altTextDescription: PropTypes.string,
    maxSquareFeet: PropTypes.number,
    acres: PropTypes.number,
  }),
  images: PropTypes.arrayOf(PropTypes.shape({ reference: PropTypes.string })),
  imgComponent: PropTypes.object,
  imageQueryString: PropTypes.string,
  showPricing: PropTypes.bool,
  useSlideshow: PropTypes.bool,
  showFavoritingHeart: PropTypes.bool,
  isInStock: PropTypes.bool,
  showStockIndicator: PropTypes.bool,
  showSpecs: PropTypes.bool,
  cardLink: PropTypes.string,
  cardLinkTarget: PropTypes.string,
  isFavorited: PropTypes.bool,
  handleFavoriteClick: PropTypes.func,
  className: PropTypes.string,
  numberInStock: PropTypes.number,
  modelId: PropTypes.number,
  modelNumber: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  baths: PropTypes.number,
  beds: PropTypes.number,
  squareFeet: PropTypes.number,
  lowPrice: PropTypes.number,
  virtualTourReference: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  hasVirtualTour: PropTypes.bool,
  altTextDescription: PropTypes.string,
  showArrows: PropTypes.bool,
  autoPlay: PropTypes.bool,
  showIndicators: PropTypes.bool,
  showThumbs: PropTypes.bool,
  swipeable: PropTypes.bool,
  emulateTouch: PropTypes.bool,
  infiniteLoop: PropTypes.bool,
  dynamicHeight: PropTypes.bool,
  customPriceMarkupCallback: PropTypes.string,
  viewportWidth: PropTypes.number,
  onClick: PropTypes.func,
  acres: PropTypes.number,
};

export default HomeCard;
